import { isRejectedWithValue, Middleware, PayloadAction } from '@reduxjs/toolkit';
import { transferApi } from './transferSlice';
import { throwErrorToast } from 'helpers/functions/toasts';
import { MetadataApiErrorPayload } from 'types';
import { errorMessages } from 'helpers/data/toastMessages';
import { getOAuth2StartUrl } from 'utils/oauth';

export const transferApiQueryErrorLogger: Middleware = () => next => action => {
    if (
        isRejectedWithValue(action) &&
        action.type.split('/')[0] === transferApi.reducerPath &&
        isRejectedWithValue(action)
    ) {
        const payload = action.payload as MetadataApiErrorPayload;
        switch (payload.originalStatus || payload.status) {
            case 401:
                throwErrorToast({
                    message: errorMessages[401],
                    action,
                    errorCode: 401,
                });
                location.replace(getOAuth2StartUrl());
                break;

            case 403:
                console.warn(`Type: ${action.type}`);
                console.warn(
                    `We got a rejected action in API! (ERROR CODE 403) - ${
                        (action as PayloadAction<unknown, string, { arg: { endpointName: string } }>).meta.arg
                            .endpointName
                    }`
                );
                console.warn(action.payload);
                break;

            case 422:
                throwErrorToast({
                    message: payload.data?.title ?? errorMessages[422],
                    action,
                    errorCode: 422,
                });
                break;

            case 503:
                throwErrorToast({
                    message: payload.data?.title ?? errorMessages[503],
                    action,
                    errorCode: 503,
                });
                break;

            default:
                throwErrorToast({
                    message: errorMessages[500],
                    action,
                    errorCode: 500,
                });
                break;
        }
    }

    return next(action);
};
